import { Button as AntButton } from 'antd';
import styled from 'styled-components';

export const Button = styled(AntButton)`
  && {
    font-weight: 500;
    letter-spacing: -0.01em;
    padding: 3px 15px;
    height: 30px;
  }

  &.save-btn {
    border: 1px solid #0046ff !important;
    color: #0046ff !important;
  }

  &.cancel-btn {
    border: 1px solid #686868;
    color: #494949;
  }

  &.delete-btn {
    border: 1px solid #d0021b;
    color: #d0021b;
  }

  &.disabled {
    opacity: 0.4;
  }
`;
